// extracted by css-extract-rspack-plugin
export default {"label_override":"Ijrt2","labelOverride":"Ijrt2","#":"ks7c9"};